'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (hashtag) {
  if (!hashtag) {
    return false;
  }

  var extracted = (0, _extractHashtags2.default)(hashtag);

  // Should extract the hashtag minus the # sign, hence the .slice(1)
  return extracted.length === 1 && extracted[0] === hashtag.slice(1);
};

var _extractHashtags = require('./extractHashtags');

var _extractHashtags2 = _interopRequireDefault(_extractHashtags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];